export const buildRowsFromStandings = (
    driverStandingsItems = [],
) => {
  return (driverStandingsItems || []).map((driverItem = {}) => {
    const roundsArray = driverItem.rounds || [];

    const rounds = roundsArray.map((round) => ({
      raceId: round.raceId,
      // carried through for the standings table header, which labels each round column
      shortName: round.shortName,
      flag: round.flag,
      points: round.points || 0,
      participated: round.participated,
      dropped: round.dropped,
    }));

    const droppedPoints = roundsArray.reduce((sum, r) => {
      if (!r.dropped) return sum;
      return sum + (r.points || 0);
    }, 0);

    const pointsWithDrops = (driverItem.points || 0) + droppedPoints;

    return {
      position: driverItem.position,
      name: `${driverItem.driver?.firstName} ${driverItem.driver?.lastName}`,
      team: driverItem.driver.team?.name || "",
      points: driverItem.points || 0,
      pointsWithDrops,
      id: driverItem.driver.id,
      rounds,
      color: driverItem.driver.team?.color || "#ffffff",
      driver: driverItem.driver,
    };
  });
};

export const buildRowsFromTeamStandings = (teamStandingsItems = []) => {
  return (teamStandingsItems || []).map((teamItem = {}) => {
    const team = teamItem.team || {};
    const rounds = (teamItem.rounds || []).map((round) => ({
      raceId: round.raceId,
      shortName: round.shortName,
      flag: round.flag,
      points: round.points || 0,
      participated: round.participated,
      // Teams never drop rounds (ADR-0008); the backend always sends false here.
      dropped: round.dropped,
    }));

    return {
      position: teamItem.position,
      name: team.name || "",
      drivers: (team.drivers || []).map((driver) => `${driver.firstName} ${driver.lastName}`),
      points: teamItem.points || 0,
      id: team.id,
      rounds,
      color: team.color || "#ffffff",
      team,
    };
  });
};

// A season can come back with no team standings at all (special events never have them),
// or with a division map whose every list is empty.
export const isTeamsEmpty = (teams) => {
  if (!teams) return true;
  if (Array.isArray(teams)) {
    return teams.length === 0;
  }
  const values = Object.values(teams);
  if (values.length === 0) return true;
  return values.every((list) => Array.isArray(list) && list.length === 0);
};
